export function tryDeriveEndpointName() {
  // Frontend bundlers do not allow destructuring process.env!
  const SETTINGS_URL = process.env.SETTINGS_URL;

  return SETTINGS_URL?.replace(/(http|https):\/\//g, '').replace(/api\.virtuallucyweb\.co\.uk\/.*/g, '');
}
